export default __webpack_public_path__ + "static/media/arrow-up.3835b92f.svg";